import { Controller } from "@hotwired/stimulus"
import { requestConfirm, pluralize } from "../util"

export default class extends Controller {
  static targets = ["form", "confirmButton", "tagsInput"]
  static values = { usersCount: Number }

  connect() {
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.formTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd)
    this.toggleSubmitButton()
  }

  disconnect() {
    if (this.hasFormTarget) {
      this.formTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
    }
  }

  async confirmAddTags(event) {
    event.preventDefault()

    const confirmed = await requestConfirm({
      modal: "default-confirm",
      data: this.modalData()
    })

    if (!confirmed) return

    this.formTarget.requestSubmit()
  }

  toggleSubmitButton() {
    if (!this.hasConfirmButtonTarget) return

    this.confirmButtonTarget.disabled = !this.hasSelectedTags()
  }

  handleSubmitEnd(event) {
    if (!event.detail.fetchResponse?.response.ok) return

    this.element.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }))
    this.element.dispatchEvent(new CustomEvent("table-checkboxes:clear", { bubbles: true }))
  }

  modalData() {
    const ambassadorsLabel = pluralize(this.usersCountValue, "ambassador", "ambassadors")
    const tagsLabel = pluralize(this.selectedTagsCount(), "tag", "tags")

    return {
      title: `Add ${tagsLabel} to ${ambassadorsLabel}`,
      text: "The selected tags will be added to the selected ambassadors. Tags they already have will remain unchanged."
    }
  }

  hasSelectedTags() {
    return this.selectedTagsCount() > 0
  }

  selectedTagsCount() {
    return this.hasTagsInputTarget
      ? this.tagsInputTarget.querySelectorAll("option:checked").length
      : 0
  }
}
